/* eslint-disable import/prefer-default-export */
/**
 * @class MissingFieldsError
 * Used for reporting unavailable actions due to missing information within
 * the User class.
 */
export class MissingFieldsError extends Error {
}
